import React, { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { ErrorBoundarySadWolf } from '@platform/client/components/error-boundaries/error-boundary-sad-wolf';

import { Cipher } from '@features/cipher-chatbot/index';
import {
  FullScreenLoader,
  FullScreenLoaderFallback,
} from '@packages/components/loader/full-screen-loader';
import { RtkAuthProvider } from '@packages/legacy/auth';
import { initFeatureFlags } from '@packages/platform/feature-flags';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import { setDayjsLocale } from '@packages/utils/dayjs.utils';
import { env } from '@packages/utils/env';
import { Root } from 'ae-kernel/root';
import { SelectedOrganizationProvider } from 'ae-kernel/selected-organization-provider/selected-organization-provider';

import '@rtkwlf/fenrir-react/style.css';

setDayjsLocale();

if (env.MODE !== 'e2e') {
  initFeatureFlags();
}

export const App: React.FC = () => {
  const [cipherFF] = useFeatureFlag('CIPHER_CHATBOT');

  return (
    <Suspense>
      <ErrorBoundarySadWolf>
        <Root fallback={<FullScreenLoaderFallback />}>
          <RtkAuthProvider onAuthRedirect={<FullScreenLoader />}>
            <SelectedOrganizationProvider>
              <Outlet />
              {cipherFF && <Cipher />}
            </SelectedOrganizationProvider>
          </RtkAuthProvider>
        </Root>
      </ErrorBoundarySadWolf>
    </Suspense>
  );
};
